<template>
  <div class="m:container lg:mx-8">
    <UnreadGrid :siteName="siteName" />
  </div>
</template>

<script>
import UnreadGrid from '../components/UnreadGrid.vue';

export default {
	components: {
		UnreadGrid
	},
	data(){
		return {
			siteName: this.$route.params.site_name
		};
	},
	mounted(){
		document.title = '👁️ ' + this.siteName + ' | URBTEC';
	}
};
</script>